// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__CiGlN","mainNav":"Navigation_mainNav__Akerd","placeHolderShimmer":"Navigation_placeHolderShimmer__--NjQ"};